/**
 * `heysegment acknowledge` — accept an override for the session's version.
 *
 * Records that this session knowingly proceeds despite contention (drift or a
 * concurrent session), unblocking the next push/deploy at the current revision.
 * The VTM runs this after the UI confirms; locally it's the manual release valve.
 *
 * @module
 */
import { Console, Effect } from "effect"
import { Command } from "effect/unstable/cli"
import { withSession, step } from "../session/with-session"
import { SessionClient } from "../rpc"
import { apiUrlFlag, dirFlag } from "./flags"

export const acknowledgeCommand = Command.make(
  "acknowledge",
  { dir: dirFlag, apiUrl: apiUrlFlag },
  (flags) =>
    withSession({ dir: flags.dir, apiUrl: flags.apiUrl }, (session) =>
      Effect.gen(function* () {
        const client = yield* SessionClient
        const state = yield* step("acknowledge", client.acknowledgeOverride(void 0))

        yield* Console.log(
          `✓ Override acknowledged for version ${session.versionId} at revision ${state.currentRevision}.`,
        )
        yield* Console.log(
          state.safeToPush
            ? "You can now push (this will overwrite concurrent changes)."
            : "Warning: still not safe to push — re-check with `heysegment check`.",
        )
      }),
    ),
).pipe(
  Command.withDescription("Acknowledge an override so push/deploy can proceed despite contention"),
)
